import { Box, IconDone, Typography } from '@capitalise/ui-design-system';

interface IBulletProps {
  label: string;
}

const Bullet = ({ label }: IBulletProps) => {
  return (
    <Box display="flex" gridGap="tiny">
      <IconDone color="green" />
      <Typography size="body-16" color="grey-700">
        {label}
      </Typography>
    </Box>
  );
};

const InviteTeamBenefits = () => {
  return (
    <Box display="flex" flexDirection="column" gridGap="tiny">
      <Typography size="heading-18" color="grey-900">
        Every team member gets access to all our features including:
      </Typography>
      <Bullet label="Share, follow and collaborate on funding searches" />
      <Bullet label="Access to the Capitalise funding certification" />
      <Bullet label="Track and monitor funding with intelligent reporting" />
    </Box>
  );
};

export default InviteTeamBenefits;
